import { Box, ThemeProvider } from "@mui/material";
import React from "react";
import { CASTORO_THEME } from "../styles/theme";
const PrivacyPolicyPage = () => {
    return (React.createElement(ThemeProvider, { theme: CASTORO_THEME },
        React.createElement(Box, { sx: {
                maxWidth: "4xl",
                margin: "0 auto",
                paddingTop: 5,
                paddingBottom: 5,
                paddingLeft: { xs: 4, sm: 10, md: 20 },
                paddingRight: { xs: 4, sm: 10, md: 20 },
            } })));
};
export default PrivacyPolicyPage;
